import {CalculatorConditionsEnum} from "../../calculations/model/CalculatorCondition";
import {Calculator, CalculatorName} from "../../calculations/model/Calculator";
import {OpportunityAction} from "../../opportunity_actions/model/OpportunityAction";
import {Address} from "../../address/model/Address";

export interface CalculationNotificationQuickPriceResult {
    id: number;
    selected: boolean;
    calculationExecutionId: number;
    point: number;
    productCode: String;
    apr: number;
    payment: number;
    term: number;
    productType: string;
    rate: number;
}

export interface CalculationLoanInfoDto {
    productName: string;
    loanTerm: number;
    loanAmount: number;
    interestRate: number;
    propertyPrice: number;
    monthlyPayment: number;
}

export enum OpportunityEventType {
    REMOVED
}

export interface EmployeeOpportunityDTO {
    id: number;
    active: boolean;
    name: string;
    licensed: boolean;
}

export interface CalculationNotificationCustomerDTO {
    id: number;
    firstName: string;
    lastName: string;
    employeeName: string;
    employee: EmployeeOpportunityDTO;
    isSubscribedToEmailCampaign :boolean;
    isSmsDeliverable: boolean;
}

export interface AvmExecutionResult {
    id: number;
    lowPropertyPrice: number;
    midPropertyPrice: number;
    highPropertyPrice: number;
    streetAddress: string;
    city: string;
    state: string;
    streetSuffix: string;
    zip: string;
}

export interface EventInfo {
    id: number;
    eventId: string;
    eventType: string;
    experianConsumerIdentifier: string;
    eventDisplayCode: string;
    monitoredAccount: string;
    consumerStatementIndicator: string;
    factaCode: string;
    fcraattr: string;
    eventDeliveryDate: Date;
    companyId: string;
    portfolioId: string;
    campaignId: string;
    versionNum: string;
    customerSpecifiedName: string;
    gen: string;
    customerSuppliedFirstName: string;
    customerSuppliedMiddleName: string;
    customerSuppliedLastName: string;
    customerSuppliedGen: string;
    ssn: string;
    address: Address;
    bestAddressPrimaryStreetId: string;
    bestAddressPreDirectional: string;
    bestAddressStreetName: string;
    bestAddressPostDirectional: string;
    bestAddressStreetSuffix: string;
    bestAddressUnitType: string;
    bestAddressUnitID: string;
    bestAddressCity: string;
    bestAddressState: string;
    bestAddressZip: string;
    nonStandardAddress: string;
    customerSuppliedData: string;
    kob: string;
    purposeType: string;
    inquiryDate: Date;
}

export interface CalculationNotificationConditionDTO {
    id: number;
    conditionType: CalculatorConditionsEnum;
    calculatorName: CalculatorName;
    isActive: boolean;
    calculationTitle: string;

}


interface ApplicationInfoDTO {
    isEpo: boolean;
    underwriterName:string;
}

export interface Opportunity {
    id: number;
    calculator: Calculator;
    executionResultLqb: CalculationNotificationQuickPriceResult;
    loanInfo: CalculationLoanInfoDto;
    customer: CalculationNotificationCustomerDTO;
    applicationInfo: ApplicationInfoDTO;
    avmExecutionResult: AvmExecutionResult;
    evenInfo: EventInfo;
    isEpo?: boolean;
    createdAt: Date;
    finishedAt: Date;
    isSuccess: boolean;
    notificationText: string;
}

export interface OpportunityWithActions extends Opportunity {
    actions: OpportunityAction[];
}

export interface Identifiable {
    id: number;
}

export interface OpportunityLog extends Identifiable {
    id: number;
    calculatorName: string;
    startedExecution: Date;
    finishedExecution: Date;
    customerFirstName: string;
    customerLastName: string;
    loanOfficerFirstName: string;
    loanOfficerLastName: string;
    imageUrl: string;
}